export default __webpack_public_path__ + "static/media/IconIndividual.962ae4a1.png";